import { Quill} from 'vue-quill-editor'
let Embed = Quill.import('blots/embed');

class MathBlot extends Embed {
    static create(value) {
        let node = super.create(value);
        if (typeof value === 'string') {
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }

    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
}

MathBlot.blotName = 'math';
MathBlot.className = 'ql-formula';
MathBlot.tagName = 'SPAN';



Quill.register(MathBlot, true)
